import { Drawer } from "antd";
import { useState } from "react";
import { BurgerIcon } from "src/assets/Icons";
import ModulesMenu from "../../ModulesMenu/ModulesMenu";

export default function ModulesMenuDrawer() {
  const [open, setOpen] = useState(false);

  return (
    <div className="flex items-center justify-center">
      <Drawer
        open={open}
        onClose={() => setOpen(false)}
        placement="right"
        size={"80%"}
        styles={{ body: { padding: 0 } }}
        classNames={{
          header: "border-none!",
        }}
      >
        <ModulesMenu onSelect={() => setOpen(false)} />
      </Drawer>
      <button
        className="flex cursor-pointer items-center justify-center rounded-full p-2 border border-border-default text-icon-default"
        onClick={() => setOpen(true)}
      >
        <BurgerIcon strokeWidth={1} className="h-4 w-4" />
      </button>
    </div>
  );
}
